import { defineComponent as i, computed as l, openBlock as n, createBlock as r, mergeProps as d, withCtx as u, createElementBlock as c, toDisplayString as m, createCommentVNode as f, createElementVNode as o, createVNode as p, unref as g } from "vue";
import { IconLoading as v } from "@accor/icons";
import { AdsIcon as _ } from "../icon/index.js";
import { _ as x } from "../../chunks/index.99cfd0be.js";
import './index.css';const C = ["textContent"], $ = /* @__PURE__ */ i({
  name: "AdsLoading",
  __name: "index",
  props: {
    text: {},
    variation: { default: "default" },
    size: { default: "default" },
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(a) {
    const s = l(() => ["ads-loading", a.variation && `ads-loading--${a.variation}`, `ads-loading--${a.size}`]);
    return (e, t) => (n(), r(x, d({
      as: e.as,
      asChild: e.asChild
    }, {
      class: s.value,
      role: "alert",
      "aria-live": "assertive"
    }), {
      default: u(() => [
        e.text ? (n(), c("p", {
          key: 0,
          class: "sr-only",
          textContent: m(e.text)
        }, null, 8, C)) : f("", !0),
        t[0] || (t[0] = o("svg", {
          viewBox: "0 0 70 70",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          o("circle", {
            cx: "35",
            cy: "35",
            r: "29"
          })
        ], -1)),
        p(_, { url: g(v) }, null, 8, ["url"])
      ]),
      _: 1
    }, 16, ["class"]));
  }
});
export {
  $ as AdsLoading
};
